import { useDispatch } from 'react-redux';
import { FetchStatus } from 'data/core';
import { addSpaceTab, saveSpaceTabs } from 'data/space-tabs';
import { useSpaceDetailQuery } from 'queries';

export const useSpace = (spaceId: number) => {
  const dispatch = useDispatch();

  const { data, ...rest } = useSpaceDetailQuery(spaceId, {
    enabled: !Number.isNaN(Number(spaceId)),
    onSuccess: (res) => {
      if (res.spaceTabs.length > 0) {
        dispatch(
          saveSpaceTabs({
            data: res.spaceTabs,
            fetchStatus: FetchStatus.Partial,
          }),
        );
      } else {
        /* Show empty tab */
        dispatch(addSpaceTab({ spaceTabId: 'new', space: { spaceId } }));
      }
    },
    retry: 2,
  });

  return {
    data,
    ...rest,
  };
};
